<template>
  <AvatarComponent
    :color="color"
    :text="initialsForName"
    :tooltip="name"
    :size="size"
    :square="true"
  />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { types as usersTypes } from '../../store/users';
import AvatarComponent from './AvatarComponent';
import { getColorForId } from '../../tools/UsersColors';

export default {
  name: 'GroupAvatar',
  components: {
    AvatarComponent,
  },
  props: {
    groupId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 18,
    },
  },
  computed: {
    ...mapGetters({
      usersProfiles: usersTypes.getters.usersProfiles,
    }),
    avatarColor() {
      if (this.usersProfiles && this.userId) {
        const profile = this.usersProfiles[this.userId];
        if (!profile) {
          return { color: 'grey', text: 'white' };
        }
        return profile.avatarColor;
      }
      return { color: 'grey', text: 'white' };
    },
    initialsForName() {
      return this.name ? this.name.split(' ').map(n => n.substring(0, 1)).join('') : '';
    },
    userInitials() {
      if (this.usersProfiles && this.userId) {
        const profile = this.usersProfiles[this.userId];
        if (!profile) {
          return '';
        }
        return profile.firstName.substring(0, 1) + profile.lastName.substring(0, 1);
      }

      return '';
    },
    color() {
      return getColorForId(this.groupdId);
    },
  },
  beforeMount() {
    if (this.userId && (!this.usersProfiles || !this.usersProfiles[this.userId])) {
      this.getUserProfile(this.userId);
    }
  },
  methods: {
    ...mapActions({
      getUserProfile: usersTypes.actions.getUserProfile,
    }),
  },
  watch: {
    userId(nextUserId) {
      if (nextUserId && (!this.usersProfiles || !this.usersProfiles[nextUserId])) {
        this.getUserProfile(nextUserId);
      }
    },
  },
};
</script>
<style>
.mini-avatar {
  font-size: 10px;
}
</style>
